export const defaultCarouselParams: object = {
	direction: 'horizontal',
	shouldSwiperUpdate: true,
	spaceBetween: 15,
	slidesPerView: 3,
	slidesPerGroup: 1,
	noSwiping: true,
	speed: 1000,
	watchOverflow: true,
	watchSlidesVisibility: true,
	containerModifierClass: 'swiper-container-overlay '
};

export const testimonialsParams: object = {
	direction: 'horizontal',
	shouldSwiperUpdate: true,
	spaceBetween: 5,
	slidesPerView: 1,
	noSwiping: true,
	loop: true,
	speed: 1000,
	autoplay: {
		delay: 10000,
		disableOnInteraction: false
	},
	watchOverflow: true
};


